module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2OC4zIDc3LjAxIj4NCiAgPHBhdGggZD0ibTAgNjkuMzIgOC42OSA3LjY5aDguNjFsNTAuOTktMzIuMTVWMzIuMTRMMTcuMyAwSDguNjlMMCA3LjY5djYxLjYzWk0xMy41OCA5IDU5LjMgMzUuODd2NS4yNkwxMy41OCA2OC41NmwtNS4yOS00LjU1VjEzLjMzTDEzLjU4IDlaIiBzdHlsZT0iZmlsbDojZmZmIiBkYXRhLW5hbWU9IkxheWVyXzEiLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/play-new.svg
// module id = 849
// module chunks = 0